import React, {useState} from 'react';
import { View, StyleSheet } from 'react-native';
import CommonExpandContainer from '../CommonExpand/CommonExpandContainer';
import CommonImpactSeizuresGraph from '../CommonImpact/CommonImpactSeizuresGraph';
import CommonImpactTriggersGraph from './CommonImpactTriggersGraph';
import CommonImpactAurasGraph from './CommonImpactAurasGraph';
import CommonImpactMoodSleepAdhGraph from './CommonImpactMoodSleepAdh/CommonImpactMoodSleepAdhGraph';
import GlobalStyles from 'common/src/styles/GlobalStyles';
import Text from '../CommonCustomTxt';
import {widthPercentageToDP as PR} from 'common/src/styles/PixelRatio';
import { useTranslation } from 'react-i18next';

type OwnProps = {
    data: DataTypes[],
}

interface DataTypes {
    itemType: string,
    itemTitle: string,
    icon?: string,
    Me?: MeTypes,
    Events?: any
}

interface MeTypes {
    patientData: Record<string,any>,
    result: Record<string,any>
}

const CommonImpactContainer = ({data}:OwnProps) => {
    const {t} = useTranslation();
    const [expandedSection, setExpandedSection] = useState<number>(-1)

    const updateDisplayList = (expandedIndex) => {
        setExpandedSection(expandedSection === expandedIndex ? -1 : expandedIndex)
    }

    return(
        <>
            {data.map((item:DataTypes, index:number) => {
                return(
                    <View key={index}>
                        <CommonExpandContainer 
                            dataItem={item}
                            isExpanded={expandedSection === index ? true : false} 
                            updateDisplayList={updateDisplayList} 
                            index={index}
                            children={
                                <>
                                {item.itemType === 'seizures' && item?.Events && item?.Me &&
                                    <>
                                        <CommonImpactSeizuresGraph 
                                            Me={item.Me}
                                            Events={item.Events}
                                        />
                                    </>
                                } 
                                {item.itemType === 'triggers' && item?.Events.length > 0 && 
                                    <>
                                        <CommonImpactTriggersGraph 
                                            Events={item.Events}
                                            triggersAurasType={item.itemType}
                                        />
                                    </>
                                }
                                {item.itemType === 'triggers' && item?.Events.length === 0 &&
                                    <Text style={styles.bottomPlaceholder}>{t('translation:programs.impact.triggers.placeholder')}</Text>
                                }
                                {item.itemType === 'auras' && item?.Events.length > 0 &&
                                    <>
                                        <CommonImpactAurasGraph 
                                            Events={item.Events}
                                            eventType={item.itemType}
                                        />
                                    </>
                                } 
                                {item.itemType === 'auras' && item?.Events.length === 0 &&
                                    <Text style={styles.bottomPlaceholder}>{t('translation:programs.impact.auras.placeholder')}</Text>
                                }
                                {item.itemType === 'mood' && item?.Events && 
                                    <>
                                        <CommonImpactMoodSleepAdhGraph 
                                            Events={item.Events}
                                            eventType={item.itemType}
                                        />
                                    </>
                                } 
                                {item.itemType === 'sleep' && item?.Events && 
                                    <>
                                        <CommonImpactMoodSleepAdhGraph 
                                            Events={item.Events}
                                            eventType={item.itemType}
                                        />
                                    </>
                                }
                                {item.itemType === 'reminder' && item?.Events && 
                                    <>
                                        <CommonImpactMoodSleepAdhGraph 
                                            Events={item.Events}
                                            eventType={item.itemType}
                                        />
                                    </>
                                }
                                </>
                            }
                        />
                    </View>
                )
            })}
        </>
    )
}
const styles = StyleSheet.create({
    bottomPlaceholder: {
        fontSize: PR(12),
        fontFamily: GlobalStyles.global.fontFamily.Regular,
        color: GlobalStyles.global.black,
        opacity: 0.8,
        textAlign:'center'
    },
});

export default CommonImpactContainer;